export const FETCH_TB_MICRO_RESULTS_REQUEST = "FETCH_TB_MICRO_RESULTS_REQUEST";
export const FETCH_TB_MICRO_RESULTS_SUCCESS = "FETCH_TB_MICRO_RESULTS_SUCCESS";
export const FETCH_TB_MICRO_RESULTS_FAILURE = "FETCH_TB_MICRO_RESULTS_FAILURE";